<template>
    <div style="margin-top:5px; align-self: flex-start; display: flex; justify-content: flex-start; min-height: 36px; overflow: hidden; min-width: 165px; position: fixed; top:90px"
         v-if="show">
        <v-btn color="primary" :rounded="true"
               style="transition: all .4s; cursor: default; text-transform: none"
               :class="{'info-btn-hidden': !$vuetify.rtl, 'info-btn-hidden-rtl': $vuetify.rtl}">


          <v-icon color="white" style="margin-right: 8px; margin-left:8px;">mdi-timer</v-icon>
          <span>{{$t('general.timer.provide_answer_in')}} {{formattedTime}}</span>
        </v-btn>
    </div>
</template>

<script>
    export default {
        name: "QuestionTimerDisplay",
        props: {
            show: {type: Boolean, default: false},
            secondsLeft: {type: Number, default: 0},
        },
        data: () => ({
            hovering: false,
        }),
      computed: {
        formattedTime() {
          if(this.secondsLeft===null){
            return "";
          }
          const min = Math.floor(this.secondsLeft / 60);
          const sec = this.secondsLeft % 60;
          return `${min.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;
        }
      },
        methods: {

        }
    }
</script>

<style scoped>
    .info-btn-hidden {
        transform: translateX(-15px);
        display: flex;
        justify-content: flex-start;
    }

    .info-btn-hidden-rtl {
        transform: translateX(15px);
        display: flex;
        justify-content: flex-start;
    }
</style>